import 'jquery-scrollify';
import AOS from 'aos';

export default {
  init() {
    // JavaScript to be fired on all pages

    $.scrollify({
      section: '.section',
      //sectionName : 'section-name',
      interstitialSection: '.header, footer',
      easing: false,
      scrollSpeed: 500,
      offset : 0,
      scrollbars: true,
      standardScrollElements: '',
      setHeights: true,
      overflowScroll: true,
      updateHash: true,
      touchScroll: true,
      before:function() {},
      after:function() {},
      afterResize:function() {},
      afterRender:function() {},
    });

    $('.arrow').click(function(e){
      e.preventDefault()
      $.scrollify.move(1);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    
    AOS.init();

    function sectionHeight() {
      let height = document.body.height = window.innerHeight;
      $('.section, .landing').css('height', height);
      console.log(height);
    }

    window.onresize = function() {
      sectionHeight();
    }
    window.onresize(); // called to initially set the height.




    // $('.landing__logo').delay(1000).fadeIn();
    // $('.landing__arrow').delay(2000).addClass('show');

    


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js